import React, { useEffect, useRef } from 'react';
import { getUserMentions } from '../../../../../services/dashboard.service';
import { displayErrorNotification } from '../../../../../utils/displayNudosStandardNotifications';
import { MENTION_STATUS } from '../../../../../types/dashboard.types';
import useMentionsState from '../../../../../state/useMentionsState';
import { MentionsColumn } from './MentionsColumn/MentionsColumn';

import './Tab1Mentions.scss';

/**
 * Componente que representa el primer tab del dashboard, correspondiente a la sección de menciones
 * @returns {JSX.Element} Componente Tab1Mentions
 */
const Tab1Mentions: React.FC = () => {
  const {
    pendingViewingMentions,
    pendingResolutionMentions,
    resolvedMentions,
    isColumnsLoading,
    setIsColumnsLoading,
    updateAllMentions
  } = useMentionsState();

  const hasLoadedRef = useRef(false);

  const obtainMentions = async (showLoader = false) => {
    try {
      if (showLoader) setIsColumnsLoading(true);

      const response = await getUserMentions();
      updateAllMentions({
        pendingViewingMentions: response?.pendingViewingMentions || [],
        pendingResolutionMentions: response?.pendingResolutionMentions || [],
        resolvedMentions: response?.resolvedMentions || []
      });
    } catch (error) {
      displayErrorNotification();
    } finally {
      if (showLoader) setIsColumnsLoading(false);
    }
  };

  useEffect(() => {
    // Solo hacer la carga inicial una vez
    if (!hasLoadedRef.current) {
      hasLoadedRef.current = true;
      obtainMentions(true);
    }
  }, []);

  return (
    <div className="tab1Mentions">
      <h2 className="mentionsTitle">Te han mencionado</h2>

      <div className="mentionsColumnsContainer">
        <MentionsColumn
          status={MENTION_STATUS.PENDING_VIEWING}
          groupedMentions={pendingViewingMentions}
          isLoading={isColumnsLoading}
          onReloadData={() => obtainMentions(true)}
        />

        <MentionsColumn
          status={MENTION_STATUS.PENDING_RESOLUTION}
          groupedMentions={pendingResolutionMentions}
          isLoading={isColumnsLoading}
          onReloadData={() => obtainMentions(true)}
        />

        <MentionsColumn
          status={MENTION_STATUS.CLOSED}
          groupedMentions={resolvedMentions}
          isLoading={isColumnsLoading}
          onReloadData={() => obtainMentions(true)}
        />
      </div>
    </div>
  );
};

export default Tab1Mentions;
